import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { Link } from 'react-router-dom'

import warningIcon from '../../../../assests/images/warning-icon.svg'

import { isNumber, verifyEmail, verifyLength, verifyPassword } from '../../../../helper'
import { verifyMobileNumber } from '../../../../helpers/helper'
import { addAdminUser } from '../../../../actions/user'

function AddAdminUser(props) {

  const [email, setEmail] = useState('')
  const [MobNum, setMobNum] = useState()
  const [password, setPassword] = useState('')
  const [errEmail, setErrEmail] = useState('')
  const [errMobNum, setErrMobNum] = useState('')
  const [errPassword, setErrPassword] = useState('')
  const [message, setMessage] = useState('')
  const [, setStatus] = useState(true)
  const [loading, setLoading] = useState('')
  const [modalMessage, setModalMessage] = useState(false)
  const toggleMessage = () => setModalMessage(!modalMessage)

  const dispatch = useDispatch()
  const token = useSelector(state => state.auth.token)
  const resMessage = useSelector(state => state.user.resMessage)
  const resStatus = useSelector(state => state.user.resStatus)
  const previousProps = useRef({ resMessage }).current


  useEffect(() => {
    if (previousProps.resMessage !== resMessage) {
      if (resMessage) {
        setMessage(resMessage)
        setStatus(resStatus)
        setLoading(false)
        if (resStatus) {
          props.history.push('/users/admin-user', { message: resMessage })
        } else {
          setModalMessage(true)
        }
      }
    }
    return () => {
      previousProps.resMessage = resMessage
    }
  }, [resMessage])

  function handleChange(event, type) {
    switch (type) {
      case 'Email':
        if (verifyLength(event?.target.value, 1) && verifyEmail(event?.target?.value)) {
          setErrEmail('')
        } else if (!verifyEmail(event?.target?.value)) {
          setErrEmail('Enter Valid Email')
        } 
        setEmail(event?.target?.value)
        break
      case 'MobileNum':
        if (verifyMobileNumber(event?.target?.value, 1) && verifyMobileNumber(event?.target?.value)) {
          setErrMobNum('')
        } else if (!verifyLength(event?.target?.value, 1)) {
          setErrMobNum('Required field')
        } else {
          setErrMobNum('Must contain 10 digits')
        }
        setMobNum(event?.target?.value)
        break
      case 'Password':
        if (verifyPassword(event?.target?.value)) {
          setErrPassword('')
        } else {
          setErrPassword('Must contain minimum 8 characters and maximum 15 characters')
        }
        setPassword(event?.target?.value)
        break
      default:
        break
    }
  }

  function onSubmit(e) {
    e.preventDefault()
    if (verifyLength(email, 1) && verifyEmail(email) && verifyMobileNumber(MobNum, 1) && verifyLength(MobNum, 10) &&verifyLength(password, 1) &&verifyPassword(password) &&
      !errEmail &&!errMobNum &&!errPassword) {
      dispatch(addAdminUser(email, MobNum, password, token))
    } else {
      if(!email) {
        setErrEmail('Required field')
      } else if (!verifyEmail(email)){
        setErrEmail('Enter Valid Email')
      }if(MobNum?.length !== 10) {
        setErrMobNum('Number must be 10 digits')
      }
      if(!MobNum) {
        setErrMobNum('Required field')
      }else if(!isNumber(MobNum)){
        setErrMobNum('Enter only numbers')
      } 
      if (!verifyLength(password, 8)) {
        setErrPassword('Required field')
      }
    }
  }

  return (
    <main className="main-content">
      <section className="common-form-block">
        <h2>Add Admin User</h2>
        {loading}  
            <Fragment>
              <Form onSubmit={onSubmit}>
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input type="email" name="email" placeholder="Enter Email" value={email} onChange={event => handleChange(event, 'Email')} />
                  <p className="error-text">{errEmail}</p>
                </FormGroup>
                <FormGroup>
                  <Label for="mobileNumber">Mobile Number</Label>
                  <Input type="tel" name="mobileNumber" placeholder="Enter Mobile Number" value={MobNum} onChange={event => handleChange(event, 'MobileNum')} />
                  <p className="error-text">{errMobNum}</p>
                </FormGroup>
                <FormGroup>
                  <Label for="password">Password</Label>
                  <Input type="password" name="password" placeholder="Set Password" value={password} onChange={event => handleChange(event, 'Password')} />
                  <p className="error-text">{errPassword}</p>
                </FormGroup>
                <Button type="submit" className="theme-btn full-btn">add admin user</Button>
              </Form>
              <div className="form-footer text-center small-text">
                <Link to='/users/admin-user'>Cancel</Link>
              </div>
            </Fragment>
          
        
      </section>
      <Modal isOpen={modalMessage} toggle={toggleMessage} className="modal-approve">
        <ModalBody className="text-center">
          <img className="info-icon" src={warningIcon} alt="check" />
          <h2>Failed</h2>
          <p className="small-text light-text">{message}</p>
          <Button type="submit" className="theme-btn danger-btn full-btn" onClick={toggleMessage}>OK</Button>
        </ModalBody>
      </Modal>
    </main>
  )
}

export default AddAdminUser